import React from 'react';

import View from './view';
import {Props} from './model';

export const NameInfo = (props: Props) => {
  return <View {...props} />;
};
